import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

export default function useComscoreTracking() {
  const location = useLocation();
  const isFirstLoad = useRef(true);

  useEffect(() => {
    if (isFirstLoad.current) {
      isFirstLoad.current = false;
      return;
    }

    if (window.COMSCORE) {
      window.COMSCORE.beacon({
        c1: '2',
        c2: '28893285',
      });
    }
  }, [location.pathname]);
}
